import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import FolderOpen from 'Icons/FolderOpen';
import Laptop from 'Icons/Laptop';
import { Box } from '@material-ui/core';
import Uploader from 'Components/Files/GenericUploader/Uploader';
import LoadingOverlay from 'Components/UI/LoadingOverlay/LoadingOverlay';


const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    gap: '16px',
    width: '100%',
  },
  uploadSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.facet.backgroundGray,
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
    fontWeight: theme.typography.fontWeightMedium,
  },
  icon: {
    height: '3em',
    width: '3em',
  },
});


function SelectLinkTypeView({
  classes, message, uploadRelationship, onSelectFile, onComplete, onError, onSuccess,
}) {
  const [loading, setLoading] = React.useState(false);

  return (
    <Box className={classes.root}>
      {loading && <LoadingOverlay />}
      <Box p={2}>
        <Typography>
          {message}
        </Typography>
        <div className={classes.container}>
          <Box
            p={2}
            component="button"
            className={classes.uploadSection}
            onClick={onSelectFile}
          >
            <Laptop className={classes.icon} />
            <Typography color="primary">
              {'Add from Secure Files'}
            </Typography>
          </Box>
          <Uploader
            url={uploadRelationship}
            onFinally={() => {
              setLoading(false);
              onComplete();
            }}
            onStart={() => setLoading(true)}
            onSuccess={onSuccess}
            onCatch={onError}
          >
            <Box
              p={2}
              component="button"
              className={classes.uploadSection}
            >
              <FolderOpen className={classes.icon} />
              <Typography color="primary">
                {'Upload from device'}
              </Typography>
            </Box>
          </Uploader>
        </div>
      </Box>
    </Box>
  );
}

SelectLinkTypeView.defaultProps = {
  message: 'Please select where to add a document from.',
};

SelectLinkTypeView.propTypes = {
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onSelectFile: PropTypes.func.isRequired,
  uploadRelationship: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
};

export default withStyles(styles)(SelectLinkTypeView);
